import React, { useState } from 'react';
import { H1, IconCheck, Modal } from '../../../components';
import { useIntl } from 'react-intl';
import ContactUsForm from './ContactUsForm';
import api from '../../../api';

import css from './SectionContactUs.module.css';
import classNames from 'classnames';

const SectionContactUs = props => {
  const { className, name, email, userId, onManageDisableScrolling, ...rest } = props;

  const [modalSuccessOpen, setModalSuccessOpen] = useState(false);
  const [sendingEmailError, setSendingEmailError] = useState(false);

  const intl = useIntl();

  const sendEmail = async formValues => {
    const { message: text, ...rest } = formValues;
    setSendingEmailError(false);

    return await api.emails
      .sendContactUsEmail({ text, ...rest })
      .then(() => {
        setModalSuccessOpen(true);
      })
      .catch(e => {
        setSendingEmailError(true);
        throw new Error(e);
      });
  };

  return (
    <div className={classNames(css.root, className)}>
      <H1 className={css.h1}>
        {intl.formatMessage(
          { id: 'ContactUsPage.heading' },
          { span: text => <span className={css.marketplaceColoredText}>{text}</span> }
        )}
      </H1>
      <p className={css.description}>{intl.formatMessage({ id: 'ContactUsPage.description' })}</p>
      <ContactUsForm
        onSubmit={sendEmail}
        initialValues={{ email, name, ...(!!userId && { userId }), message: '' }}
        {...rest}
      />
      {sendingEmailError && (
        <span className={css.error}>
          {intl.formatMessage({ id: 'ContactUsPage.sendingEmailFailed' })}
        </span>
      )}
      <Modal
        id="success-email-modal"
        isOpen={modalSuccessOpen}
        onClose={() => {
          setModalSuccessOpen(false);
        }}
        onManageDisableScrolling={onManageDisableScrolling}
      >
        <div className={css.successModal}>
          <div className={css.successModalTitle}>
            {intl.formatMessage({ id: 'General.thankYou' })}
          </div>
          <div className={css.successModalContent}>
            <IconCheck className={css.icon} />
            {intl.formatMessage({ id: 'ContactUsPage.sendingEmailSuccess' })}
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default SectionContactUs;
